import { useEffect, useState } from 'react';

export function wrapAxisLabel(value, maxChars = 16) {
  const text = String(value || '').trim();
  if (!text) return [''];
  if (text.length <= maxChars) return [text];

  const words = text.split(/\s+/);
  const lines = [];
  let current = '';
  words.forEach((word) => {
    const next = current ? `${current} ${word}` : word;
    if (next.length <= maxChars) {
      current = next;
      return;
    }
    if (current) lines.push(current);
    current = word.length > maxChars ? `${word.slice(0, maxChars - 1)}…` : word;
  });
  if (current) lines.push(current);
  return lines.slice(0, 3);
}

export function useChartBreakpoint() {
  const [bp, setBp] = useState('md');

  useEffect(() => {
    const apply = () => {
      const width = window.innerWidth;
      if (width < 640) setBp('sm');
      else if (width < 1024) setBp('md');
      else setBp('lg');
    };
    apply();
    window.addEventListener('resize', apply);
    return () => window.removeEventListener('resize', apply);
  }, []);

  return bp;
}

export function hubAxisWidth(breakpoint) {
  if (breakpoint === 'sm') return 92;
  if (breakpoint === 'md') return 120;
  return 148;
}

export function hubAxisMaxChars(breakpoint) {
  if (breakpoint === 'sm') return 12;
  if (breakpoint === 'md') return 16;
  return 20;
}

export function hubChartHeight(count, breakpoint) {
  const row = breakpoint === 'sm' ? 44 : 40;
  const min = breakpoint === 'sm' ? 220 : 260;
  return Math.min(Math.max(min, (count || 1) * row + 48), 480);
}

export function HubCategoryTick({ x, y, payload, maxChars = 16 }) {
  const lines = wrapAxisLabel(payload?.value, maxChars);
  const offset = ((lines.length - 1) * 6);

  return (
    <g transform={`translate(${x},${y})`}>
      <title>{payload?.value}</title>
      {lines.map((line, index) => (
        <text
          key={`${line}-${index}`}
          x={-6}
          y={index * 12 - offset}
          dy={4}
          textAnchor="end"
          fontSize={11}
          fill="#4b5563"
        >
          {line}
        </text>
      ))}
    </g>
  );
}

export function DateCategoryTick({ x, y, payload }) {
  return (
    <g transform={`translate(${x},${y})`}>
      <title>{payload?.value}</title>
      <text x={0} y={0} dy={12} textAnchor="middle" fontSize={10} fill="#6b7280">
        {payload?.value}
      </text>
    </g>
  );
}
